export const PageTypes = {
  CART: 'CART',
  CHECKOUT: 'CHECKOUT',
  PDP: 'PDP',
  PLP: 'PLP'
} as const;
